<template>
  <div class="uk-container">
    <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">{{ user.profile.name.first }} {{ user.profile.name.last }}</h3>
        <p class="uk-text-meta">Your Profile</p>
      </div>
      <div class="uk-card-body uk-text-center">
        <p><b>First Name</b>: {{ user.profile.name.first }}</p>
        <p><b>Last Name</b>: {{ user.profile.name.last }}</p>
        <p><b>Account Type</b>: {{ type | capitalize }}</p>
        <p><b>Email</b>: {{ user.profile.email }}</p>
        <p class="uk-remove-margin-bottom"><b>ID</b>: {{ user.record.uid }}</p>
      </div>
      <div class="uk-card-footer uk-text-center">
        <button class="uk-button uk-button-primary" uk-tooltip="Update your Profile Details, including password." href="#modal-update" uk-toggle>Update Profile</button>
      </div>
    </div>

    <div id="modal-update" uk-modal="bg-close: false;">
      <div class="uk-modal-dialog uk-width-large">
        <div class="uk-modal-header uk-text-center">
          <h3 class="uk-card-title">Update Profile</h3>
          <p class="uk-text-meta"><b>Note</b>: If you change your email or password you will be automatically logged out and will need to log back in.</p>
        </div>
        <div class="uk-modal-body">
          <user-form ref="form-profile" type="manage" :user="user.profile" />
        </div>
        <div class="uk-modal-footer uk-text-center">
          <button class="uk-button uk-button-danger uk-modal-close uk-margin-small-right" type="button">Cancel</button>
          <button class="uk-button uk-button-primary" type="button" :disabled="updateDisabled" @click="update">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserForm from '@/components/form/User.vue'

export default {
  name: 'ViewProfile',

  components: {
    UserForm
  },

  filters: {
    capitalize: (value) => {
      if (!value) return ''
      const string = value.toString()
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  },

  data() {
    return {
      formData: null,
      formComponent: null
    }
  },

  computed: {
    user() {
      return this.$store.state.account
    },

    type() {
      return this.$store.getters['account/type']
    },

    updateDisabled() {
      return this.formComponent ? !this.formComponent.observer.flags.valid : true
    }
  },

  mounted() {
    this.formComponent = this.$refs['form-profile']
    this.formData = this.formComponent.form
  },

  destroyed() {
    document.querySelectorAll('.uk-modal').forEach((element) => {
      element.remove()
    })
  },

  methods: {
    async update() {
      this.$uikit.modal('#modal-update').hide()

      const valid = await this.formComponent.validate()
      let result = null

      if (valid) {
        const loader = this.$loader.show({ message: 'Updating User Record', overlayOpacity: 1 })

        try {
          const updateUser = this.$firebaseFunctions.httpsCallable('updateUser')
          const data = {}

          if (this.formData.email !== this.user.email) {
            data.email = this.formData.email
          }

          if (this.formData.password !== null) {
            data.password = this.formData.password
          }

          if (this.formData.name.first !== this.user.profile.name.first || this.formData.name.last !== this.user.profile.name.last) {
            if (data.hasOwnProperty('name')) {
              data.name.first = this.formData.name.first
              data.name.last = this.formData.name.last
            } else {
              data.name = {}
              data.name.first = this.formData.name.first
              data.name.last = this.formData.name.last
            }
          }

          data.uid = 'self'
          result = await updateUser(data)
        } catch (error) {
          result = error
          await loader.hide(true)
          this.$uikit.notification(error, { status: 'danger' })
        }

        if ((result instanceof Error !== true) && result.data.status === 'success') {
          this.$firebase.auth().currentUser.reload()
          await loader.hide()

          if (this.$firebase.auth().currentUser) {
            this.$uikit.modal.alert('Profile was updated successfully!')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.uk-tooltip {
  max-width: 400px !important;
}
</style>
